import { render } from "./modal-plane-auto-v2.vue?vue&type=template&id=2f6d02b6&scoped=true&ts=true"
import script from "./modal-plane-auto-v2.vue?vue&type=script&lang=ts"
export * from "./modal-plane-auto-v2.vue?vue&type=script&lang=ts"

import "./modal-plane-auto-v2.vue?vue&type=style&index=0&id=2f6d02b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6d02b6"]])

export default __exports__